import useDefinedContext from "hooks/useDefinedContext";
import AthleteActionsContext from "../contexts/AthleteActionsContext";

function useAthleteActions() {
  return useDefinedContext(AthleteActionsContext);
}

export default useAthleteActions;
